import type {
  ContentFitnessCoverageStatus,
  ContentFitnessVerificationState,
} from "contracts/enums/content-fitness";
import {
  CONTENT_FITNESS_COVERAGE_STATUS,
  CONTENT_FITNESS_VERIFICATION_STATE,
} from "contracts/enums/content-fitness";
import type { CrawlRunStatus } from "contracts/enums/core";
import { CRAWL_RUN_STATUS, isActiveCrawlRunStatus } from "contracts/enums/core";

export const CLIENT_TERMS = {
  assessmentCriteria: "Assessment criteria",
  assessmentCoverage: "Assessment coverage",
} as const;

export function coverageLabel(
  status: ContentFitnessCoverageStatus | null,
): string {
  if (status === CONTENT_FITNESS_COVERAGE_STATUS.FULL) return "Fully assessed";
  if (status === CONTENT_FITNESS_COVERAGE_STATUS.PARTIAL)
    return "Partially assessed";
  return "No scored data";
}

export function verificationStateLabel(
  state: ContentFitnessVerificationState,
): string {
  if (state === CONTENT_FITNESS_VERIFICATION_STATE.UNABLE_TO_VERIFY)
    return "Unable to verify";
  if (state === CONTENT_FITNESS_VERIFICATION_STATE.NOT_APPLICABLE)
    return "Not applicable";
  return "Scored";
}

export function criteriaCoverageLabel(assessed: number, total: number): string {
  return `${assessed} of ${total} criteria assessed`;
}

export function runStatusLabel(
  status: CrawlRunStatus,
  partial: boolean,
): string {
  if (isActiveCrawlRunStatus(status)) return "In progress";
  if (status === CRAWL_RUN_STATUS.FAILED) return "Failed";
  return partial ? "Completed with partial coverage" : "Completed";
}
